import { ActivityPathId } from '@/api/models/aggregate'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const findActivityPartsFlattenParentsByActivityPathId = (
  activityWithAggregates: FrontActivityWithAggregate,
  activityPathId: ActivityPathId,
): FrontActivityPart<FrontActivityWithAggregate>[] => {
  const activityParts: FrontActivityPart<FrontActivityWithAggregate>[] = [
    {
      childActivity: activityWithAggregates,
      activityPathId: '' as ActivityPathId,
      available: true,
    } as FrontActivityPart<FrontActivityWithAggregate>,
  ]

  if (!activityWithAggregates || !activityPathId) {
    return activityParts
  }

  const activityPartIds = activityPathId.split('/')

  let current: FrontActivityWithAggregate | null = activityWithAggregates

  for (let i = 0; i < activityPartIds.length; i++) {
    const activityPart: FrontActivityPart<FrontActivityWithAggregate> | undefined = (current?.children ?? []).find(
      ({ id }) => id === activityPartIds[i],
    )

    if (!activityPart) {
      throw Error('Could not find activity by activityPathId in tree')
    }

    activityParts.push(activityPart)
    current = activityPart.childActivity
  }

  return activityParts
}
